import * as core from '../../../../../../../core'

import { query } from './health-check-table.query'

export const RESOURCE = {
  payload: {
    alias: 'health-check-table',
    description:
      'Table Showing Health Checks with ability to drill down to different levels of a health check.',
    name: 'Health Check Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
